import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon } from 'design-system/icons/Icon';
import useColors from 'hooks/useColors';
const IconArrowCollapsed = (props) => {
    const colors = useColors();
    return (<Icon {...props}>
      <Path d="M10.557 16.026c-.048-.047-.255-.225-.425-.39-1.069-.972-2.819-3.505-3.353-4.83-.086-.202-.267-.71-.279-.983 0-.26.06-.509.182-.746.17-.295.437-.532.753-.662.22-.084.875-.214.887-.214.717-.13 1.883-.201 3.171-.201 1.228 0 2.346.071 3.075.178.011.012.826.142 1.105.284.51.26.827.77.827 1.314v.047c-.012.355-.33 1.101-.34 1.101-.536 1.255-2.2 3.729-3.306 4.723 0 0-.284.28-.461.402-.256.19-.571.284-.887.284-.353 0-.681-.106-.949-.307Z" fill={props.color ?? colors.elements.secondary}/>
    </Icon>);
};
export default IconArrowCollapsed;
